import React, { useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { toast } from "react-toastify";
import {
  resolveCsvAction,
  runAfterDropdownClose,
  useHasProcessedData,
} from "./IncomeListHelpers";

const IncomeRowActions = ({
  row,
  onCsvAction,
  onRetry,
  onViewReport,
  onEdit,
  onDelete,
  onGenerateInvoice,
  isProcessPending,
  isReprocessPending,
  isDeletePending,
  isRetryPending,
  isInvoicePending,
}) => {
  const [open, setOpen] = useState(false);
  const isStreaming = row.source_type !== "youtube";
  const hasProcessedData = useHasProcessedData(row.id, row.report_id, row);
  const csvAction = resolveCsvAction(row);
  const canRetry = row.can_retry_lambda ?? false;
  const csvPending = isProcessPending || isReprocessPending;
  const canInvoice =
    row.source_type === "youtube" &&
    row.youtube_type === "artists_revenue" &&
    row.label_id;

  const closeMenu = () => setOpen(false);

  const runAction = (handler) => {
    closeMenu();
    runAfterDropdownClose(handler);
  };

  const handleCsvClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (csvPending) return;

    if (csvAction.type === "none") {
      runAction(() => toast.info(csvAction.hint));
      return;
    }

    runAction(() => onCsvAction(row, csvAction.type));
  };

  return (
    <Dropdown
      isOpen={open}
      toggle={() => setOpen((value) => !value)}
      className="inc-actions-menu"
    >
      <DropdownToggle size="sm" color="light" caret className="inc-actions-menu__toggle">
        Actions
      </DropdownToggle>
      <DropdownMenu end container="body" className="inc-actions-menu__list">
        {isStreaming ? (
          <>
            <DropdownItem
              className={
                csvAction.type === "none"
                  ? "inc-actions-menu__item--muted"
                  : csvAction.type === "reprocess"
                    ? "inc-actions-menu__item--reprocess"
                    : undefined
              }
              title={csvAction.hint}
              onClick={handleCsvClick}
            >
              <i className={`fa ${csvAction.type === "reprocess" ? "fa-repeat" : "fa-cogs"} me-2`} />
              {csvPending ? "Working…" : csvAction.label}
            </DropdownItem>
            {canRetry ? (
              <DropdownItem
                disabled={isRetryPending}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  runAction(() => onRetry(row.id));
                }}
              >
                <i className="fa fa-refresh me-2" />
                {isRetryPending ? "Retrying…" : "Retry Lambda"}
              </DropdownItem>
            ) : null}
            <DropdownItem
              disabled={!hasProcessedData}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                runAction(() => onViewReport(row.id, row.report_id));
              }}
            >
              <i className="fa fa-file-text-o me-2" />
              View report
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                runAction(() => onEdit(row));
              }}
            >
              <i className="fa fa-pencil me-2" />
              Edit
            </DropdownItem>
            <DropdownItem
              className="text-danger"
              disabled={isProcessPending || isDeletePending}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (isProcessPending || isDeletePending) return;
                runAction(() => onDelete(row));
              }}
            >
              <i className="fa fa-trash me-2" />
              {isDeletePending ? "Deleting…" : "Delete"}
            </DropdownItem>
          </>
        ) : (
          <>
            <DropdownItem
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                runAction(() => onEdit(row));
              }}
            >
              <i className="fa fa-youtube-play me-2" />
              View videos &amp; revenue
            </DropdownItem>
            {canInvoice ? (
              <DropdownItem
                disabled={isInvoicePending}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  runAction(() => onGenerateInvoice(row));
                }}
              >
                <i className="fa fa-file-text-o me-2" />
                Generate invoice
              </DropdownItem>
            ) : null}
            <DropdownItem divider />
            <DropdownItem
              className="text-danger"
              disabled={isDeletePending}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (isDeletePending) return;
                runAction(() => onDelete(row));
              }}
            >
              <i className="fa fa-trash me-2" />
              {isDeletePending ? "Deleting…" : "Delete"}
            </DropdownItem>
          </>
        )}
      </DropdownMenu>
    </Dropdown>
  );
};

export default IncomeRowActions;
